var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 14.25H28V12.75C28 12.336 27.664 12 27.25 12H26.5C26.086 12 25.75 12.336 25.75 12.75V14.25H18.25V12.75C18.25 12.336 17.914 12 17.5 12H16.75C16.336 12 16 12.336 16 12.75V14.25H15.25C14.0095 14.25 13 15.2595 13 16.5V27.75C13 28.9905 14.0095 30 15.25 30H28.75C29.9905 30 31 28.9905 31 27.75V16.5C31 15.2595 29.9905 14.25 28.75 14.25ZM29.5 27.75C29.5 28.1632 29.1632 28.5 28.75 28.5H15.25C14.8368 28.5 14.5 28.1632 14.5 27.75V19.53H29.5V27.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSheduleIcon);
export default __webpack_public_path__ + "static/media/active-shedule-icon.d4cd2cba0f5d569ca538d2c8bc08f84a.svg";
export { ForwardRef as ReactComponent };